import { render, staticRenderFns } from "./khalDetail.vue?vue&type=template&id=41c3c13a&scoped=true&"
import script from "./khalDetail.vue?vue&type=script&lang=js&"
export * from "./khalDetail.vue?vue&type=script&lang=js&"
import style0 from "./khalDetail.vue?vue&type=style&index=0&id=41c3c13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c3c13a",
  null
  
)

export default component.exports